module.exports = __webpack_public_path__ + "853fdffc2b2c2078fec7699dac5bef0c.svg";